import { render, staticRenderFns } from "./MinuteTypeList.vue?vue&type=template&id=56c55990&scoped=true&"
import script from "./MinuteTypeList.vue?vue&type=script&lang=ts&"
export * from "./MinuteTypeList.vue?vue&type=script&lang=ts&"
import style0 from "./MinuteTypeList.vue?vue&type=style&index=0&id=56c55990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c55990",
  null
  
)

export default component.exports